export default __webpack_public_path__ + "static/media/americanexpress-light.45030f93.svg";